<div class="theme-switcher">
  <ng-container *ngTemplateOutlet="moonSVG" />

  <label class="switch">
    <input
      type="checkbox"
      [checked]="userPref.isLightTheme()"
      (click)="userPref.toggleTheme()" />
    <div class="slider">
      <div class="circle"></div>
    </div>
  </label>

  <ng-container *ngTemplateOutlet="sunSVG" />
</div>

<ng-template #moonSVG>
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      class="theme-switcher-moon"
      d="M18.2 14.6C12.7 14.6 8.20001 10.1 8.20001 4.6C8.20001 3.7 8.30001 2.8 8.60001 2C4.30001 3.1 1.20001 7 1.20001 11.6C1.20001 17.1 5.70001 21.6 11.2 21.6C15.8 21.6 19.7 18.5 20.8 14.2C20 14.5 19.1 14.6 18.2 14.6Z"
      fill="#D1D5D9"
      stroke="#D1D5D9"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
  </svg>
</ng-template>

<ng-template #sunSVG>
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      class="theme-switcher-sun"
      d="M1 12H2"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M4.20001 4.20001L4.90001 4.90001"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M12 1V2"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M19.8 4.20001L19.1 4.90001"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M23 12H22"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M19.8 19.8L19.1 19.1"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M12 23V22"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M4.20001 19.8L4.90001 19.1"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
    <path
      class="theme-switcher-sun"
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
      fill="#1A2F42"
      stroke="#1A2F42"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square" />
  </svg>
</ng-template>
